package es.subastia.data.di

import es.subastia.data.createDataStore
import es.subastia.data.repository.AuctionsRepositoryImpl
import es.subastia.data.repository.AuthRepositoryImpl
import es.subastia.data.repository.FavoritesRepositoryImpl
import es.subastia.data.repository.SavedSearchRepositoryImpl
import es.subastia.data.repository.UserRepositoryImpl
import es.subastia.domain.repository.AuctionsRepository
import es.subastia.domain.repository.AuthRepository
import es.subastia.domain.repository.FavoritesRepository
import es.subastia.domain.repository.SavedSearchRepository
import es.subastia.domain.repository.UserRepository
import es.subastia.domain.usecase.GetAuctionDetailUseCase
import es.subastia.domain.usecase.GetAuctionsUseCase
import es.subastia.domain.usecase.GetFavoritesUseCase
import es.subastia.domain.usecase.GetUserPreferencesUseCase
import es.subastia.domain.usecase.IsFavoriteUseCase
import es.subastia.domain.usecase.LogoutUseCase
import es.subastia.domain.usecase.ObserveAuthStateUseCase
import es.subastia.domain.usecase.SaveUserPreferencesUseCase
import es.subastia.domain.usecase.SignInWithEmailUseCase
import es.subastia.domain.usecase.SignInWithGoogleUseCase
import es.subastia.domain.usecase.SignUpWithEmailUseCase
import es.subastia.domain.usecase.DeleteSearchUseCase
import es.subastia.domain.usecase.GetSavedSearchesUseCase
import es.subastia.domain.usecase.SaveSearchUseCase
import es.subastia.domain.usecase.ToggleFavoriteUseCase
import org.koin.dsl.module

val dataModule = module {
    single { createDataStore() }

    // Repositories
    single<UserRepository> { UserRepositoryImpl(get()) }
    single<AuctionsRepository> { AuctionsRepositoryImpl() }
    single<AuthRepository> { AuthRepositoryImpl() }
    single<FavoritesRepository> { FavoritesRepositoryImpl() }

    // UseCases
    factory { GetAuctionsUseCase(get()) }
    factory { GetAuctionDetailUseCase(get()) }
    factory { GetUserPreferencesUseCase(get()) }
    factory { SaveUserPreferencesUseCase(get()) }
    factory { GetFavoritesUseCase(get()) }
    factory { IsFavoriteUseCase(get()) }
    factory { ToggleFavoriteUseCase(get()) }
    factory { ObserveAuthStateUseCase(get()) }
    factory { SignInWithEmailUseCase(get()) }
    factory { SignUpWithEmailUseCase(get()) }
    factory { SignInWithGoogleUseCase(get()) }
    factory { LogoutUseCase(get()) }
    factory { SaveSearchUseCase(get()) }
    factory { GetSavedSearchesUseCase(get()) }
    factory { DeleteSearchUseCase(get()) }

    single<SavedSearchRepository> { SavedSearchRepositoryImpl() }
}
